import { getRefPageLocalStorage } from "../shared/helpers/ref-page";
import { AssessmentClickEventName } from "./button-click-event-name";

const platformContext = "S4L";
const screenViewedEventName = "ScreenViewed";
const clickButtonEventName = "ClickButton";

export const dataLayerEventAcesso = (user: any) => {
  if (user) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      email: user.login,
      userId: user.cognitoUsername,
      time:
        user.userTeam?.length > 0
          ? user.userTeam[0].team?.displayName
          : "Sem time associado",

      event: "acesso",
    });
  }
};

export const dataLayerEvent = (event: string, params: any) => {
  const ref = getRefPageLocalStorage();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
    ref,
  });
};

interface TagManagerEvent {
  screenName: string;
  businessContext: string;
  platformContext: string;
}

interface PageViewEvents {
  Home: {
    S4L_HOME: TagManagerEvent;
  };
  Ranking: {
    S4L_RANKING_ARTISTS: TagManagerEvent;
    S4L_RANKING_COMPOSER_PRODUCER: TagManagerEvent;
    S4L_RANKING_RELEASES: TagManagerEvent;
    S4L_RANKING_TRACKS: TagManagerEvent;
    S4L_RANKING_LABELS: TagManagerEvent;
    S4L_ARTIST_NETWORK: TagManagerEvent;
  };
  Profile: {
    S4L_ARTIST_PROFILE: TagManagerEvent;
    S4L_LABEL_PROFILE: TagManagerEvent;
  };
  Comparator: {
    S4L_ARTIST_COMPARATOR: TagManagerEvent;
  };
  Assessment: {
    S4L_ARTIST_ASSESSMENT: TagManagerEvent;
  };
}

export const tagManagerEvent: PageViewEvents = {
  Home: {
    S4L_HOME: {
      screenName: "S4L_HOME",
      businessContext: "HOME",
      platformContext,
    },
  },
  Ranking: {
    S4L_RANKING_ARTISTS: {
      screenName: "S4L_RANKING_ARTISTS",
      businessContext: "RANKING",
      platformContext,
    },
    S4L_RANKING_COMPOSER_PRODUCER: {
      screenName: "S4L_RANKING_COMPOSER_PRODUCER",
      businessContext: "RANKING",
      platformContext,
    },
    S4L_RANKING_RELEASES: {
      screenName: "S4L_RANKING_RELEASES",
      businessContext: "RANKING",
      platformContext,
    },
    S4L_RANKING_TRACKS: {
      screenName: "S4L_RANKING_TRACKS",
      businessContext: "RANKING",
      platformContext,
    },
    S4L_RANKING_LABELS: {
      screenName: "S4L_RANKING_LABELS",
      businessContext: "RANKING",
      platformContext,
    },
    S4L_ARTIST_NETWORK: {
      screenName: "S4L_ARTIST_NETWORK",
      businessContext: "RANKING",
      platformContext,
    },
  },
  Profile: {
    S4L_ARTIST_PROFILE: {
      screenName: "S4L_ARTIST_PROFILE",
      businessContext: "PROFILE",
      platformContext,
    },
    S4L_LABEL_PROFILE: {
      screenName: "S4L_LABEL_PROFILE",
      businessContext: "PROFILE",
      platformContext,
    },
  },
  Comparator: {
    S4L_ARTIST_COMPARATOR: {
      screenName: "S4L_ARTIST_COMPARATOR",
      businessContext: "COMPARATOR",
      platformContext,
    },
  },
  Assessment: {
    S4L_ARTIST_ASSESSMENT: {
      screenName: "S4L_ARTIST_ASSESSMENT",
      businessContext: "ASSESSMENT",
      platformContext,
    },
  },
};

export const dataLayerViewedEvent = (event: any) => {
  dataLayerEvent(screenViewedEventName, { ...event });
};

export const dataLayerClickedEvent = (
  buttonName: AssessmentClickEventName,
  event: any
) => {
  dataLayerEvent(clickButtonEventName, { buttonName, ...event });
};

export const dataLayerErrorEvent = (
  errorName: string,
  //  LoginErrorEventName,
  event: any
) => {
  dataLayerEvent("ErrorDialog", { errorName, ...event });
};
